const { formatNumber } = require('./formatNumber')

/**
 * Szám visszaadása formázva, pénznem jelöléssel.
 * @param {unknown} x - A szám.
 * @param {string} currency - Pénznem.
 * @returns {string} A formázott szám.
 */
module.exports.formatCurrency = function formatCurrency (x, currency = 'Ft') {
  const tmp  = formatNumber(x)
  const num  = tmp === '' ? 0 : tmp

  return `${ num } ${ currency }`
}
